import { useSelector } from 'react-redux'
import { positionDropdown } from '../../../../common/dropdown'
import { Checkbox } from '../../../../common/html/checkbox'
import { Element } from '../../../../common/html/element'
import { SelectCustom } from '../../../../common/selectCustom'
import { selectYearReports } from '../../common/store/slice'
import classes from './index.module.scss'

export const FiscalYear = ({ selectedYears = [], onChangeYear }) => {
  const yearReports = useSelector(selectYearReports)

  const renderElement = () => {
    return (
      <Element className={classes.pr18}>
        {selectedYears.sort().join(', ')}
      </Element>
    )
  }

  const renderDropdownItem = (item) => {
    return (
      <Element
        elementName="li"
        className={classes.itemYear}
        style={{ borderColor: '#D5D5D5' }}
      >
        <Checkbox
          title={item.label}
          isCheckOnClickText
          checked={selectedYears.includes(item.value)}
          onChange={(checked) => onChangeYear(checked, item.value)}
        />
      </Element>
    )
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <SelectCustom
        data={yearReports.map((year) => ({ label: String(year), value: year }))}
        renderActiveItem={renderElement}
        renderDropdownItem={renderDropdownItem}
        style={{ fontSize: 12 }}
        className={classes.select}
        dropdownPosition={positionDropdown.BOTTOM_END_LEFT}
        minWidthDropdownEqualSelect={false}
      />
    </div>
  )
}
